import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import firebaseApp from "../fireconnect";
import { Button, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import "react-toastify/dist/ReactToastify.css";

const ClientOrder = () => {
  const [orders, setOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [orderIdToDelete, setOrderIdToDelete] = useState(null);

  useEffect(() => {
    getOrderData();
  }, []);

  const getOrderData = () => {
    let db = firebaseApp.firestore();
    db.collection("Orders")
      .get()
      .then((querySnapshot) => {
        let ordersData = [];
        querySnapshot.forEach((doc) => {
          ordersData.push({ ...doc.data(), id: doc.id });
        });
        setOrders(ordersData);
      })
      .catch((error) => {
        console.error("Error fetching orders: ", error);
        toast.error("Failed to fetch orders.");
      });
  };

  const handleViewOrder = (orderId) => {
    const order = orders.find((order) => order.id === orderId);
    setSelectedOrder(order);
    setShowModal(true);
  };

  const handleUpdateStatus = (orderId, newStatus) => {
    let db = firebaseApp.firestore();
    db.collection("Orders")
      .doc(orderId)
      .update({ status: newStatus })
      .then(() => {
        const updatedOrders = orders.map((order) =>
          order.id === orderId ? { ...order, status: newStatus } : order
        );
        setOrders(updatedOrders);

        if (selectedOrder && selectedOrder.id === orderId) {
          setSelectedOrder({ ...selectedOrder, status: newStatus });
        }

        toast.success(`Order marked as ${newStatus}`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((error) => {
        console.error("Error updating status: ", error);
        toast.error("Failed to update order status.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const handleDeleteOrder = (orderId) => {
    setOrderIdToDelete(orderId);
    setConfirmDeleteOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const db = firebaseApp.firestore();
      await db.collection("Orders").doc(orderIdToDelete).delete();

      setOrders((prev) => prev.filter((order) => order.id !== orderIdToDelete));

      toast.success("Order deleted successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setConfirmDeleteOpen(false);
      setOrderIdToDelete(null);

      if (selectedOrder && selectedOrder.id === orderIdToDelete) {
        setShowModal(false);
        setSelectedOrder(null);
      }
    } catch (error) {
      console.error("Error deleting order:", error);
      toast.error("Failed to delete order.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const columns = [
    {
      name: "userName",
      label: "User Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <div className="d-flex justify-content-center">{value}</div>
        ),
      },
    },
    {
      name: "discountedPrice",
      label: "Total Price",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <div className="d-flex justify-content-center">₹{value}</div>
        ),
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <div className="d-flex justify-content-center">{value}</div>
        ),
      },
    },
    {
      name: "createdAt",
      label: "Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const date = new Date(value.seconds * 1000);
          return (
            <div className="d-flex justify-content-center">
              {date.toLocaleString()}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Order Details",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <div className="d-flex justify-content-center">
            <Button variant="secondary" onClick={() => handleViewOrder(value)}>
              <i className="bi bi-eye-fill"></i>
            </Button>
          </div>
        ),
      },
    },
    {
      name: "id",
      label: "Delete",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <div className="d-flex justify-content-center">
            <Button
              variant="danger"
              size="sm"
              onClick={() => handleDeleteOrder(value)}
            >
              <i className="bi bi-trash3-fill"></i>
            </Button>
          </div>
        ),
      },
    },
  ];

  return (
    <div>
      <h4 className="mb-2">Orders</h4>
      <MUIDataTable
        data={orders}
        columns={columns}
        options={{
          tableBodyHeight: "57vh",
          selectableRows: "none",
          responsive: "standard",
        }}
      />

      {selectedOrder && (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Order Details</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
            }}
          >
            {selectedOrder.image && (
              <div className="text-center mb-3 d-grid">
                <img
                  src={selectedOrder.image}
                  alt="Product"
                  style={{
                    maxWidth: "auto",
                    height: "200px",
                  }}
                />
              </div>
            )}
            <div>
              <strong>Full Name :</strong> {selectedOrder.userName}
            </div>
            <div>
              <strong>Mobile Number :</strong> {selectedOrder.mobileNumber}
            </div>
            <div>
              <strong>Address :</strong> {selectedOrder.address}
            </div>
            <br />
            <div>
              <strong>Product Name :</strong> {selectedOrder.pname}
            </div>
            <div>
              <strong>Category :</strong> {selectedOrder.category}
            </div>
            <div>
              <strong>Price :</strong> ₹{selectedOrder.price}
            </div>
            <div>
              <strong>Discounted Price :</strong> ₹
              {selectedOrder.discountedPrice}
            </div>
            <br />
            <div>
              <strong>Ordered Date :</strong>{" "}
              {new Date(
                selectedOrder.createdAt.seconds * 1000
              ).toLocaleString()}
            </div>
            <div>
              <strong>Status :</strong> {selectedOrder.status}
            </div>
            <br />
            <div className="d-flex justify-content-between">
              <Button
                variant={
                  selectedOrder.status === "Completed"
                    ? "success"
                    : "outline-success"
                }
                onClick={() =>
                  selectedOrder.status === "Completed"
                    ? handleUpdateStatus(selectedOrder.id, "Pending")
                    : handleUpdateStatus(selectedOrder.id, "Completed")
                }
              >
                {selectedOrder.status === "Completed"
                  ? "Mark as Pending"
                  : "Mark as Completed"}
              </Button>

              <Button
                variant={
                  selectedOrder.status === "Cancelled"
                    ? "danger"
                    : "outline-danger"
                }
                onClick={() =>
                  selectedOrder.status === "Cancelled"
                    ? handleUpdateStatus(selectedOrder.id, "Pending")
                    : handleUpdateStatus(selectedOrder.id, "Cancelled")
                }
              >
                {selectedOrder.status === "Cancelled"
                  ? "Mark as Pending"
                  : "Mark as Cancelled"}
              </Button>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <Dialog
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this order?</p>
        </DialogContent>
        <DialogActions>
          <Button
            variant="secondary"
            onClick={() => setConfirmDeleteOpen(false)}
          >
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
    </div>
  );
};

export default ClientOrder;
